import { settingConfiguration } from '../configurations';
import { BILLING_SERVER } from '../constans';
import { HttpClient } from '../utils';

export const GetListFacture = (reservationId, callback) => {
    HttpClient.get(`${settingConfiguration.get(BILLING_SERVER)}/api/Billing/GetListFacture?reservationId=${reservationId}`, result => {
        callback(result);
    });
};